import { render, staticRenderFns } from "./IconSortAlphabetical.vue?vue&type=template&id=70ada2bc&"
import script from "./IconSortAlphabetical.vue?vue&type=script&lang=js&"
export * from "./IconSortAlphabetical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ada2bc')) {
      api.createRecord('70ada2bc', component.options)
    } else {
      api.reload('70ada2bc', component.options)
    }
    module.hot.accept("./IconSortAlphabetical.vue?vue&type=template&id=70ada2bc&", function () {
      api.rerender('70ada2bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSortAlphabetical.vue"
export default component.exports